import React from 'react';
import './Blog.css';
import { Link, useNavigate } from 'react-router-dom';
import Vectorarrow from '../../../Component/Images/Vectorarrow.png';
import authorimg from '../../../Component/Images/3.png';
import { environmentVariables } from '../../../config/env.config';
import { formatDate } from '../../../Component/DateFormat/DateFormat';

const Blog = ({ blogPosts, popularPosts, loading }) => {
  const navigate = useNavigate()
  if (loading) {
    return   <div style={{height:'100vh'}}>
      <div id="loader" class="loader"></div>;
    </div>
  }

  return (
    <div className="blog">
      <div className="blog-container">
        {/* Main Blog Posts */}
        <div className="main-content">
          {blogPosts?.length > 0 ? (
            blogPosts.map((post, index) => (
              <div className="blog-post" key={index}>
                <div className="blog-post-content">
                  <div className="blog-post-image">
                    <Link to={`/blog-page/${post?.slug}`} state={post?.id} >
                      <img
                        src={post?.image
                          ? `${environmentVariables?.apiUrlBlogs}uploads/files/${post.image}`
                          : authorimg}
                        alt={post?.title || "Blog Image"}
                        onError={(e) => { e.target.src = authorimg; }}
                      />
                    </Link>
                  </div>
                  <div className="blog-post-details">
                    <div className="post-meta-top">
                      <div className="post-date">{formatDate(post?.created_at) || 'Unknown Date'}</div>
                      {/* <div className="post-stats">
                        <span><i className="far fa-eye"></i> {post?.views || 0} Views</span>
                        <span><i className="far fa-comment"></i> {post?.comments || 0} Comments</span>
                      </div> */}
                    </div>
                    <h2 className="post-title" dangerouslySetInnerHTML={{ __html: post?.heading }}></h2>
                    <p className="post-description" dangerouslySetInnerHTML={{ __html: post?.description }}></p>
                    <div className="post-footer">
                      <div className="post-author">
                        <div className="author-image">
                        
                          <img src={post?.author?.profile_pic
                          ? `${environmentVariables?.apiUrlBlogs}uploads/files/${post?.author?.profile_pic}`
                          : authorimg} alt={post?.author?.name || 'Unknown Author'} />
                        </div>
                        <div className="author-info">
                          <div className="author-name">By {post?.author?.name || 'Unknown'}</div>
                          <div className="author-role">{post?.author?.tag || 'Blogger'}</div>
                        </div>
                      </div>
                      <div className="meta-second">
                        <p onClick={() => navigate(`/blog-page/${post?.slug}` , {state : post?.id})} className="popular-read-more">Read more</p>
                        <img src={Vectorarrow} alt="" className="arrowimg" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <p>No blogs available.</p>
          )}
        </div>

        {/* Sidebar for Popular Posts */}
        <div className="sidebar">
          <h3 className="sidebar-title">POPULAR POST</h3>
          <div className="popular-posts-section">
            <div className="popular-posts">
              {popularPosts?.length > 0 ? (
                popularPosts?.map((post, index) => (
                  <div className="popular-post" key={index} onClick={()=>navigate(`/blog-page/${post?.slug}`, {state: post?.id})}>
                    <div className="popular-post-content">
                      <div className="popular-post-image">
                        <img src={`${environmentVariables?.apiUrlBlogs}uploads/files/${post?.image}` || authorimg} alt={post?.title} />
                      </div>
                      <div className="popular-post-details">
                        <div className="popular-post-meta-top">
                          <div className="post-date">{formatDate(post?.created_at) || 'Unknown Date'}</div>
                          {/* <div className="post-stats">
                            <span><i className="far fa-eye"></i> {post?.views || 0} Views</span>
                            <span><i className="far fa-comment"></i> {post?.comments || 0} Comments</span>
                          </div> */}
                        </div>
                        <h4 className="popular-post-title" dangerouslySetInnerHTML={{ __html: post?.heading }}></h4>
                        <div className="popular-post-footer">
                          <div className="post-author">
                            <div className="author-image">
                              <img src={`${environmentVariables?.apiUrlBlogs}uploads/files/${post?.author?.profile_pic}` || authorimg} alt={post?.author?.name || 'Unknown Author'} />
                            </div>
                            <div className="author-info">
                              <div className="author-name">By {post?.author?.name || 'Unknown'}</div>
                              <div className="author-role">{post?.author?.tag || 'Blogger'}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <p>No popular blogs available.</p>
              )}
            </div>
          </div>
        </div>

        {/* Pagination */}
        {/* <div className="pagination">
          <a href="#" className="active">1</a>
          <a href="#" className='number'>2</a>
          <a href="#" className='number'>3</a>
          <a href="#">...</a>
          <a href="#" className='number'>8</a>
          <a href="#" className="next-page">Next Page →</a>
        </div> */}
      </div>
    </div>
  );
};

export default Blog;
